"use client"

import React from "react"
import { useState, useEffect } from "react"
import dayjs from "dayjs"
import axios from "axios"
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonRefresher, IonRefresherContent, useIonViewWillEnter } from "@ionic/react"
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  MenuItem,
  Button,
  Card,
  CardContent,
  Grid,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  Divider,
  Alert,
  CircularProgress,
  Tooltip,
  TablePagination,
  Collapse,
  List,
  ListItem,
  ListItemText,
  ImageList,
  ImageListItem,
  ImageListItemBar,
} from "@mui/material"
import {
  Search,
  FilterList,
  Download,
  Visibility,
  Close,
  AttachMoney,
  Receipt,
  Person,
  ExpandMore,
  ExpandLess,
  CheckCircle,
  Warning,
  Description,
  AttachFile,
  ZoomIn,
} from "@mui/icons-material"
import { DatePicker } from "@mui/x-date-pickers"

import { fetchSalesData_withdate_staffId_paymentMethodCall, getManagersOrders_reciept, getManagersOrders_reciept_withdate, getOrderTransaction, verifyTransaction } from "../../../api/reports/reports"
import { getStaffList_saleapp } from "../../../api/users/user"
import { formatCurrencyN } from "../../../common/utils_t"
import { baseUrl, config } from "../../../common/utils"
import { MenuButton } from "../../../components/Menu"

interface OrderItem {
  product_id: string
  quantity: string
  product_name: string
  price: string
  total_amount: string
  item_status: string
}

interface ProductType {
  product_id: string
  name: string
}

interface Product {
  product_id: string
  name: string
  // Add other product fields as needed from your API response
}

interface SalesTransaction {
  order_id: string
  order_code: string
  order_date: string
  mode_of_payment: string
  payable_amount: string
  balance_due: string
  order_by: string
  order_status: string
  member_id: string
  member_name: string
  payment_status: string
  otp_status: string | null
  items?: OrderItem[]
  tabBalance: number
  debtBalance: number
  walletDetails: number
  walletDetails_l: number
  amount_paid: string
  firstName: string
  // Additional fields for verification dialog
  product_id_type?: string
  customer_name?: string
  customer_phone?: string
  customer_email?: string
  customer_account_name?: string
  customer_account_number?: string
  bank_name?: string
  active_status?: string
  is_verified?: number
  is_audited?: number
  staff_name?: string
  mode_of_payment_real?: string
  card_amount?: string
  rmbValue?: string
  cryptoType?: string
  cryptoAmount?: string
  costPrice?: string
  sellingPrice?: string
  commission?: string
  external_processor?: string
  processor_type?: string
  processor_category?: string
  load_type?: string
  card_rate?: string
  naira_rate?: string
  internal_rate?: string
  created_at?: string
  last_updated?: string
  proof_of_payment?: string
  proof_of_jobstart?: string
  payout_group_id?: string
  crypto_value?: string
  // Image fields
  images?: string[]
  screenshot?: string
  transaction_proof?: string
}

interface SalesStats {
  total_sales: number
  total_orders: number
  average_order_value: number
  top_payment_method: string
  growth_percentage: number
  pending_orders: number
  completed_orders: number
}

interface Staff {
  staff_id: string
  staff_name: string
  user_id: string
  firstName: string
  lastName: string
}

interface FilterState {
  startDate: Date | null
  endDate: Date | null
  paymentMethod: string
  department: string
  orderStatus: string
  paymentStatus: string
  staffId: string
  productType: string
}

const ManagerSalesReportPage_R_Giftcard: React.FC = () => {
  const [transactions, setTransactions] = useState<SalesTransaction[]>([])
  const [filteredTransactions, setFilteredTransactions] = useState<SalesTransaction[]>([])
  const [salesStats, setSalesStats] = useState<SalesStats | null>(null)
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState("")
  const [showFilters, setShowFilters] = useState(false)
  const [showTransactionDetail, setShowTransactionDetail] = useState(false)
  const [selectedTransaction, setSelectedTransaction] = useState<SalesTransaction | null>(null)
  const [expandedRows, setExpandedRows] = useState<string[]>([])
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const [verifyDialogOpen, setVerifyDialogOpen] = useState(false)
  const [transactionToVerify, setTransactionToVerify] = useState<SalesTransaction | null>(null)
  const [isVerifying, setIsVerifying] = useState(false)
  const [verifyDialogLoading, setVerifyDialogLoading] = useState(false)
  const [imageDialogOpen, setImageDialogOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState<string>("")

  const [staffList, setStaffList] = useState<Staff[]>([])
  const [productTypes, setProductTypes] = useState<ProductType[]>([])
  const [products, setProducts] = useState<Product[]>([])

  const [filters, setFilters] = useState<FilterState>({
    startDate: dayjs().toDate(),
    endDate: dayjs().toDate(),
    paymentMethod: "",
    department: "",
    orderStatus: "",
    paymentStatus: "",
    staffId: "",
    productType: "",
  })

  const paymentMethods = ["All", "manual_transfer", "auto_transfer"]
  const orderStatuses = ["All", "COMPLETED", "PENDING", "CANCELLED"]
  const paymentStatuses = ["All", "0", "1", "2"]

  const [myBalance_due, setMyBalance_due] = useState(0)
  const [myAmount_paid, setMyAmount_paid] = useState(0)
  const [myTotal, setMyTotal] = useState(0)

  useEffect(() => {
    applyFilters()
  }, [transactions, searchQuery, filters])

  // Helper function to generate request ID
  const generateRequestID = () => {
    return `req_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`
  }

  const fetchStaffData = async () => {
    try {
      const response = await getStaffList_saleapp()
      console.log({ staffResponse: response })
      if (response.data) {
        setStaffList(response.data)
      }
    } catch (error) {
      console.error("Error fetching staff data:", error)
    }
  }

  // New function to fetch product types from the endpoint
  const fetchProductTypes = async () => {
    try {
      const payload = { requestID: generateRequestID() }
      const response = await axios.post(
        `${baseUrl()}Warehouses/getAllProducts_byBranch`,
        payload,config
      )
      console.log("Product types response:", response)
   
      if (response.data && Array.isArray(response.data)) {
        // Transform the response to match the ProductType interface
        const productTypes = response.data.map((product: Product) => ({
          product_id: product.product_id,
          name: product.name
        }))
        console.log(productTypes);
        setProductTypes(productTypes)
        setProducts(response.data)
      }
    } catch (error) {
      console.error("Error fetching product types:", error)
    }
  }

  const formatDateYMD = (date: Date) => {
    return date.toISOString().slice(0, 10)
  }

  const liveFilter = ({ startDate, endDate }: { startDate: Date | null; endDate: Date | null }) => {
    if (!startDate || !endDate) return
    const formattedStart = formatDateYMD(startDate)
    const formattedEnd = formatDateYMD(endDate)
    fetchSalesData_withdate(formattedStart, formattedEnd)
  }

  const liveFilterStaffId = ({ startDate, endDate, staffId }: { startDate: Date | null; endDate: Date | null; staffId: string }) => {
    if (!startDate || !endDate) return
    const formattedStart = formatDateYMD(startDate)
    const formattedEnd = formatDateYMD(endDate)
    fetchSalesData_withdate_staffId(formattedStart, formattedEnd, staffId)
  }

  const liveFilterStaffId_paymentMethod = ({ startDate, endDate, staffId, paymentMethod }: { startDate: Date | null; endDate: Date | null; staffId: string; paymentMethod: string }) => {
    if (!startDate || !endDate) return
    const formattedStart = formatDateYMD(startDate)
    const formattedEnd = formatDateYMD(endDate)
    fetchSalesData_withdate_staffId_paymentMethod(formattedStart, formattedEnd, staffId, paymentMethod)
  }

  const fetchSalesData_withdate_staffId_paymentMethod = async (start: string, end: string, staffId: string, paymentMethod: string) => {
    setLoading(true)
    try {
      const response = await fetchSalesData_withdate_staffId_paymentMethodCall(rowsPerPage, start, end, staffId, paymentMethod)
      console.log({ response })
     // console.log("22222Response data222ss:", response.data)

      await fetchStaffData()
      await fetchProductTypes() // Updated to use the new function

      let filteredByPaymentMethod = response.data?.orders || []
      if (paymentMethod && paymentMethod !== "All") {
        filteredByPaymentMethod = filteredByPaymentMethod.filter((txn: SalesTransaction) => txn.mode_of_payment === paymentMethod)
      }

      setTransactions(filteredByPaymentMethod)
      setMyBalance_due(response.data?.balance_due || 0)
      setMyAmount_paid(response.data?.amount_paid || 0)
      setMyTotal(response.data?.mytotal || 0)


      const totalSales = filteredByPaymentMethod?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount || 0), 0)
      const completedOrders = filteredByPaymentMethod?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = filteredByPaymentMethod?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: filteredByPaymentMethod?.length || 0,
        average_order_value: filteredByPaymentMethod?.length ? totalSales / filteredByPaymentMethod.length : 0,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders || 0,
        completed_orders: completedOrders || 0,
      })
    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSalesData_withdate_staffId = async (start: string, end: string, staffId: string) => {
    setLoading(true)
    try {
      const response = await getManagersOrders_reciept_withdate(rowsPerPage, start, end, staffId)
      console.log({ response })

      await fetchStaffData()
      await fetchProductTypes() // Updated to use the new function

      setTransactions(response.data?.orders || [])
      setMyBalance_due(response.data?.balance_due || 0)
      setMyAmount_paid(response.data?.amount_paid || 0)
      setMyTotal(response.data?.mytotal || 0)

      const totalSales = (response.data?.orders || [])?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount || 0), 0)
      const completedOrders = (response.data?.orders || [])?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = (response.data?.orders || [])?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: (response.data?.orders || [])?.length,
        average_order_value: (response.data?.orders || [])?.length ? totalSales / (response.data.orders.length) : 0,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders || 0,
        completed_orders: completedOrders || 0,
      })
    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSalesData_withdate = async (start: string, end: string) => {
    setLoading(true)
    try {
      const response = await getManagersOrders_reciept_withdate(rowsPerPage, start, end, "all")
      console.log({ response })

      await fetchStaffData()
      await fetchProductTypes() // Updated to use the new function

      setTransactions(response.data?.orders || [])
      setMyBalance_due(response.data?.balance_due || 0)
      setMyAmount_paid(response.data?.amount_paid || 0)
      setMyTotal(response.data?.mytotal || 0)

      const totalSales = (response.data?.orders || [])?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount || 0), 0)
      const completedOrders = (response.data?.orders || [])?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = (response.data?.orders || [])?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: (response.data?.orders || [])?.length,
        average_order_value: (response.data?.orders || [])?.length ? totalSales / (response.data.orders.length) : 0,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders || 0,
        completed_orders: completedOrders || 0,
      })
    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const fetchSalesData = async () => {
    setLoading(true)
    try {
      const response = await getManagersOrders_reciept(rowsPerPage)
      console.log({ response })

      await fetchStaffData()
      await fetchProductTypes() // Updated to use the new function

      setTransactions(response.data?.orders || [])
      setMyBalance_due(response.data?.balance_due || 0)
      setMyAmount_paid(response.data?.amount_paid || 0)
      setMyTotal(response.data?.mytotal || 0)

      const totalSales = (response.data?.orders || [])?.reduce((sum: number, txn: SalesTransaction) => sum + Number.parseFloat(txn.payable_amount || 0), 0)
      const completedOrders = (response.data?.orders || [])?.filter((txn: SalesTransaction) => txn.order_status === "COMPLETED").length
      const pendingOrders = (response.data?.orders || [])?.filter((txn: SalesTransaction) => txn.order_status === "PENDING").length

      setSalesStats({
        total_sales: totalSales,
        total_orders: (response.data?.orders || [])?.length,
        average_order_value: (response.data?.orders || [])?.length ? totalSales / (response.data.orders.length) : 0,
        top_payment_method: "cash",
        growth_percentage: 12.5,
        pending_orders: pendingOrders || 0,
        completed_orders: completedOrders || 0,
      })
    } catch (error) {
      console.error("Error fetching sales data:", error)
    } finally {
      setLoading(false)
    }
  }

  const applyFilters = () => {
    let filtered = transactions || []

    // Apply search filter
    if (searchQuery) {
      filtered = filtered?.filter(
        (transaction) =>
          transaction?.order_code?.toLowerCase().includes(searchQuery.toLowerCase()) ||
          (transaction?.firstName && transaction.firstName.toLowerCase().includes(searchQuery.toLowerCase())) ||
          transaction?.order_id?.toLowerCase().includes(searchQuery.toLowerCase()),
      )
    }

    if (filters.startDate && filters.endDate) {
      const start = new Date(filters.startDate)
      start.setHours(0, 0, 0, 0)

      const end = new Date(filters.endDate)
      end.setHours(23, 59, 59, 999)

      filtered = filtered?.filter((transaction) => {
        if (!transaction?.order_date) return false
        const transactionDate = new Date(transaction.order_date)
        return transactionDate >= start && transactionDate <= end
      })
    }

    // Apply payment method filter
    if (filters.paymentMethod && filters.paymentMethod !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.mode_of_payment === filters.paymentMethod)
    }

    // Apply order status filter
    if (filters.orderStatus && filters.orderStatus !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.order_status === filters.orderStatus)
    }

    // Apply payment status filter
    if (filters.paymentStatus && filters.paymentStatus !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.payment_status === filters.paymentStatus)
    }

    // Apply staff filter
    if (filters.staffId && filters.staffId !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.order_by === filters.staffId)
    }

    // Apply product type filter
    if (filters.productType && filters.productType !== "All") {
      filtered = filtered?.filter((transaction) => transaction?.product_id_type === filters.productType)
    }

    setFilteredTransactions(filtered)
  }

  const handleFilterChange = (field: keyof FilterState, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const clearFilters = () => {
    setFilters({
      startDate: dayjs().toDate(),
      endDate: dayjs().toDate(),
      paymentMethod: "",
      department: "",
      orderStatus: "",
      paymentStatus: "",
      staffId: "",
      productType: "",
    })
    setSearchQuery("")
  }

  const viewTransactionDetail = (transaction: SalesTransaction) => {
    setSelectedTransaction(transaction)
    setShowTransactionDetail(true)
  }

  const handleVerifyClick = async (transaction: SalesTransaction) => {
    setVerifyDialogOpen(true)
    setVerifyDialogLoading(true)
    
    try {
      const response = await getOrderTransaction(transaction)
      console.log({ transaction })
      console.log("Transaction details:", response.data)

      if (response.status) {
        setTransactionToVerify(response.data)
      }
    } catch (error) {
      console.error("Error verifying transaction:", error)
      alert("An error occurred during verification.")
    } finally {
      setTimeout(() => {
        setVerifyDialogLoading(false)
      }, 500)
    }
  }

  const handleVerifyTransaction = async () => {
    if (!transactionToVerify) return
    console.log(transactionToVerify.order_code)
    setIsVerifying(true)
    try {
      const response = await verifyTransaction(transactionToVerify)
      fetchSalesData()
    } catch (error) {
      console.error("Error verifying transaction:", error)
      alert("An error occurred during verification.")
    } finally {
      setIsVerifying(false)
      setVerifyDialogOpen(false)
      setTransactionToVerify(null)
    }
  }

  const handleImageClick = (imageUrl: string) => {
    setSelectedImage(imageUrl)
    setImageDialogOpen(true)
  }

  const toggleRowExpansion = (orderId: string) => {
    setExpandedRows((prev) => (prev.includes(orderId) ? prev.filter((id) => id !== orderId) : [...prev, orderId]))
  }

  const getOrderStatusColor = (status: string) => {
    if (!status) return "default"
    switch (status.toUpperCase()) {
      case "COMPLETED":
        return "success"
      case "PENDING":
        return "warning"
      case "CANCELLED":
        return "error"
      default:
        return "default"
    }
  }

  const getPaymentStatusLabel = (status: string) => {
    switch (status) {
      case "0":
        return "Unpaid"
      case "1":
        return "Paid"
      case "2":
        return "Partial"
      default:
        return "Unknown"
    }
  }

  const getPaymentStatusColor = (status: string) => {
    switch (status) {
      case "0":
        return "error"
      case "1":
        return "success"
      case "2":
        return "warning"
      default:
        return "default"
    }
  }

  const formatCurrency = (amount: string | number) => {
    const numAmount = typeof amount === "string" ? Number.parseFloat(amount) : amount
    if (isNaN(numAmount)) return "₦0.00"
    return new Intl.NumberFormat("en-NG", {
      style: "currency",
      currency: "NGN",
    }).format(numAmount)
  }

  const formatDate = (dateString: string) => {
    if (!dateString) return "Invalid Date"
    try {
      return new Date(dateString).toLocaleDateString("en-NG", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    } catch (error) {
      return "Invalid Date"
    }
  }

  const exportData = () => {
    const headers = [
      "Order Code",
      "Date",
      "Member Name",
      "Payment Method",
      "Amount",
      "Balance Due",
      "Order Status",
      "Payment Status",
      "Items Count",
    ]

    const csvContent = [
      headers.join(","),
      ...filteredTransactions.map((transaction) =>
        [
          transaction?.order_code || "",
          transaction?.order_date || "",
          `"${transaction?.firstName || ""}"`,
          transaction?.mode_of_payment || "",
          transaction?.amount_paid || "0",
          transaction?.balance_due || "0",
          transaction?.order_status || "",
          getPaymentStatusLabel(transaction?.payment_status || ""),
          transaction?.items?.length || 0,
        ].join(","),
      ),
    ].join("\n")

    const blob = new Blob([csvContent], { type: "text/csv" })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement("a")
    a.href = url
    a.download = `sales-report-${new Date().toISOString().split("T")[0]}.csv`
    a.click()
    window.URL.revokeObjectURL(url)
  }

  const paymentMethodTotals = filteredTransactions.reduce((acc, transaction) => {
    const { mode_of_payment, amount_paid } = transaction
    if (!mode_of_payment) return acc
    if (!acc[mode_of_payment]) {
      acc[mode_of_payment] = 0
    }
    acc[mode_of_payment] += Number(amount_paid || 0)
    return acc
  }, {} as Record<string, number>)

  // Function to get all images from a transaction
  const getTransactionImages = (transaction: SalesTransaction | null) => {
    if (!transaction) return []
    
    const images = []
    if (transaction.proof_of_payment) images.push(transaction.proof_of_payment)
    if (transaction.proof_of_jobstart) images.push(transaction.proof_of_jobstart)
    if (transaction.screenshot) images.push(transaction.screenshot)
    if (transaction.transaction_proof) images.push(transaction.transaction_proof)
    if (transaction.images && Array.isArray(transaction.images)) {
      images.push(...transaction.images)
    }
    
    return images.filter(img => img && img.trim() !== "")
  }

  useIonViewWillEnter(() => {
    fetchSalesData()
    fetchStaffData()
    fetchProductTypes() // Updated to use the new function
  })

  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar>  <MenuButton/>
          <IonTitle>Manager Gift Card Sales Receipt</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <IonRefresher
          slot="fixed"
          onIonRefresh={(e) => {
            fetchSalesData().finally(() => e.detail.complete())
          }}
        >
          <IonRefresherContent />
        </IonRefresher>

        <Box sx={{ p: 2 }}>
          {/* Sales Statistics Cards */}
          {salesStats && (
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "primary.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <AttachMoney sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Sold Amount
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {formatCurrencyN(Number(myTotal))}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "success.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Receipt sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Paid Amount
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {formatCurrencyN(Number(myAmount_paid))}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "warning.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <Warning sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Unpaid Amount
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {formatCurrencyN(Number(myBalance_due))}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={6} md={3}>
                <Card sx={{ bgcolor: "info.light", color: "white" }}>
                  <CardContent sx={{ textAlign: "center", py: 2 }}>
                    <CheckCircle sx={{ fontSize: 40, mb: 1 }} />
                    <Typography variant="h6" sx={{ fontSize: "0.9rem" }}>
                      Total Orders
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", fontSize: "1.2rem" }}>
                      {salesStats.total_orders}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          )}

          {/* Search and Filter Controls */}
          <Paper sx={{ p: 2, mb: 2 }}>
            <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
              <TextField
                fullWidth
                placeholder="Search by order code, member name, or order ID..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                InputProps={{
                  startAdornment: <Search sx={{ mr: 1, color: "text.secondary" }} />,
                }}
                size="small"
              />
              <Button variant="outlined" startIcon={<FilterList />} onClick={() => setShowFilters(!showFilters)}>
                Filters
              </Button>
              <Button variant="outlined" startIcon={<Download />} onClick={exportData}>
                Export
              </Button>
            </Box>

            {/* Filter Panel */}
            {showFilters && (
              <Box sx={{ borderTop: 1, borderColor: "divider", pt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={3}>
                    <DatePicker
                      label="Start Date"
                      value={dayjs(filters.startDate)}
                      onChange={(date) => {
                        const dateValue = date ? date.toDate() : null
                        handleFilterChange("startDate", dateValue)
                        liveFilter({ startDate: dateValue, endDate: filters.endDate })
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <DatePicker
                      label="End Date"
                      value={dayjs(filters.endDate)}
                      onChange={(date) => {
                        const dateValue = date ? date.toDate() : null
                        handleFilterChange("endDate", dateValue)
                        liveFilter({ startDate: filters.startDate, endDate: dateValue })
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Staff</InputLabel>
                      <Select
                        value={filters.staffId}
                        label="Staff"
                        onChange={(e) => {
                          handleFilterChange("staffId", e.target.value)
                          liveFilterStaffId({ startDate: filters.startDate, endDate: filters.endDate, staffId: e.target.value })
                        }}
                      >
                        <MenuItem value="">All Staff</MenuItem>
                        {staffList?.map((staff) => (
                          <MenuItem key={staff.user_id} value={staff.user_id}>
                            {staff.firstName} {staff.lastName}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Payment Method</InputLabel>
                      <Select
                        value={filters.paymentMethod}
                        label="Payment Method"
                        onChange={(e) => {
                          handleFilterChange("paymentMethod", e.target.value)
                          liveFilterStaffId_paymentMethod({
                            startDate: filters.startDate,
                            endDate: filters.endDate,
                            staffId: filters.staffId,
                            paymentMethod: e.target.value,
                          })
                        }}
                      >
                        {paymentMethods.map((method) => (
                          <MenuItem key={method} value={method === "All" ? "" : method}>
                            {method}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {/* Updated Product Type Filter */}
                  <Grid item xs={12} md={2}>
                    <FormControl fullWidth size="small">
                      <InputLabel>Product Type</InputLabel>
                      <Select
                        value={filters.productType}
                        label="Product Type"
                        onChange={(e) => {
                          handleFilterChange("productType", e.target.value)
                        }}
                      >
                        <MenuItem value="All">All Products</MenuItem>
                        {productTypes.map((product) => (
                          <MenuItem key={product.product_id} value={product.name}>
                            {product.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <Button variant="outlined" color="secondary" onClick={clearFilters} fullWidth>
                      Clear Filters
                    </Button>
                  </Grid>
                </Grid>
              </Box>
            )}
          </Paper>

          {/* Results Summary */}
          <Alert severity="info" sx={{ mb: 2 }}>
            Showing {filteredTransactions?.length || 0} of {transactions?.length || 0} orders
            {filters.productType && filters.productType !== "All" && (
              <span> • Filtered by: {filters.productType}</span>
            )}
          </Alert>

          {/* Transactions Table */}
          <TableContainer
            component={Paper}
            sx={{
              overflowX: "auto",
              "&::-webkit-scrollbar": {
                height: 8,
              },
              "&::-webkit-scrollbar-track": {
                backgroundColor: "#f1f1f1",
                borderRadius: 4,
              },
              "&::-webkit-scrollbar-thumb": {
                backgroundColor: "#c1c1c1",
                borderRadius: 4,
                "&:hover": {
                  backgroundColor: "#a8a8a8",
                },
              },
            }}
          >
            <Table sx={{ minWidth: 1200 }}>
              <TableHead>
                <TableRow sx={{ bgcolor: "grey.100" }}>
                  <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Order Code</TableCell>
                  <TableCell sx={{ minWidth: 150, whiteSpace: "nowrap" }}>Date</TableCell>
                  <TableCell sx={{ minWidth: 200, whiteSpace: "nowrap" }}>Staff</TableCell>
                  <TableCell sx={{ minWidth: 200, whiteSpace: "nowrap" }}>Customer</TableCell>
                  <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Product Type</TableCell>
                  <TableCell sx={{ minWidth: 120, whiteSpace: "nowrap" }}>Payment Method</TableCell>
                  <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                    Amount
                  </TableCell>
                  <TableCell align="right" sx={{ minWidth: 120, whiteSpace: "nowrap" }}>
                    Payout Due
                  </TableCell>
                  <TableCell align="center" sx={{ minWidth: 150, whiteSpace: "nowrap" }}>
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : filteredTransactions?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                      <Typography variant="body1" color="text.secondary">
                        No orders found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  <React.Fragment>
                    {filteredTransactions
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((transaction) => {
                        const isExpanded = expandedRows.includes(transaction.order_id)
                        return (
                          <React.Fragment key={transaction.order_id}>
                            <TableRow
                              sx={{
                                "&:nth-of-type(even)": { bgcolor: "grey.50" },
                                "&:hover": { bgcolor: "action.hover" },
                              }}
                            >
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold", color: "primary.main" }}>
                                  {transaction.order_code}
                                </Typography>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Typography variant="body2">{formatDate(transaction.order_date)}</Typography>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Person sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                                  <Typography variant="body2">{transaction.staffFullName || "N/A"}</Typography>
                                </Box>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                  <Person sx={{ mr: 1, fontSize: 16, color: "text.secondary" }} />
                                  <Typography variant="body2">{transaction.firstName}</Typography>
                                </Box>
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Chip 
                                  label={transaction.product_id_type || "N/A"} 
                                  size="small" 
                                  color={transaction.product_id_type === "GiftCard" ? "primary" : "secondary"} 
                                />
                              </TableCell>
                              <TableCell sx={{ whiteSpace: "nowrap" }}>
                                <Chip label={transaction.mode_of_payment} size="small" color="secondary" />
                              </TableCell>
                              <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                                <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                                  {formatCurrency(transaction.amount_paid)}
                                </Typography>
                              </TableCell>
                              <TableCell align="right" sx={{ whiteSpace: "nowrap" }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: "bold",
                                    color: Number.parseFloat(transaction.balance_due || "0") > 0 ? "error.main" : "success.main",
                                  }}
                                >
                                  {formatCurrency(transaction.balance_due)}
                                </Typography>
                              </TableCell>
                              <TableCell align="center">
                                <Box sx={{ display: "flex", gap: 1, justifyContent: "center" }}>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    color={Number(transaction.is_verified == 1) ? "success" : "error"}
                                    onClick={() => handleVerifyClick(transaction)}
                                  >
                                    {Number(transaction.is_verified == 1) ? "Verified" : "Verify"}
                                  </Button>
                                </Box>
                              </TableCell>
                            </TableRow>

                            {/* Expandable Items Row */}
                            <TableRow>
                              <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={9}>
                                <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                                  <Box sx={{ margin: 1 }}>
                                    <Typography variant="h6" gutterBottom component="div">
                                      Order Items ({transaction?.items?.length || 0})
                                    </Typography>
                                    <Table size="small">
                                      <TableHead>
                                        <TableRow>
                                          <TableCell>Product</TableCell>
                                          <TableCell align="right">Quantity</TableCell>
                                          <TableCell align="right">Unit Price</TableCell>
                                          <TableCell align="right">Total</TableCell>
                                          <TableCell>Status</TableCell>
                                        </TableRow>
                                      </TableHead>
                                      <TableBody>
                                        {transaction?.items?.map((item, index) => (
                                          <TableRow key={`${transaction.order_id}-${index}`}>
                                            <TableCell>{item.product_name}</TableCell>
                                            <TableCell align="right">{item.quantity}</TableCell>
                                            <TableCell align="right">{formatCurrency(item.price)}</TableCell>
                                            <TableCell align="right">{formatCurrency(item.total_amount)}</TableCell>
                                            <TableCell>
                                              <Chip
                                                label={item.item_status}
                                                size="small"
                                                color={getOrderStatusColor(item.item_status) as any}
                                              />
                                            </TableCell>
                                          </TableRow>
                                        )) || (
                                          <TableRow>
                                            <TableCell colSpan={5} align="center">
                                              No items found
                                            </TableCell>
                                          </TableRow>
                                        )}
                                      </TableBody>
                                    </Table>
                                  </Box>
                                </Collapse>
                              </TableCell>
                            </TableRow>
                          </React.Fragment>
                        )
                      })}
                    <TableRow sx={{ backgroundColor: "grey.200" }}>
                      <TableCell colSpan={6} align="right">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          Total
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {formatCurrency(filteredTransactions.reduce((sum, tx) => sum + Number(tx.amount_paid || 0), 0))}
                        </Typography>
                      </TableCell>
                      <TableCell align="right">
                        <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                          {formatCurrency(filteredTransactions.reduce((sum, tx) => sum + Number(tx.balance_due || 0), 0))}
                        </Typography>
                      </TableCell>
                      <TableCell></TableCell>
                    </TableRow>
                  </React.Fragment>
                )}
              </TableBody>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, 50, 500, 1000]}
              component="div"
              count={filteredTransactions?.length || 0}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={(_, newPage) => setPage(newPage)}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(Number.parseInt(e.target.value, 10))
                setPage(0)
              }}
            />
          </TableContainer>

          <Paper sx={{ p: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: "bold", color: "primary.main" }}>
              Payment Method Totals
            </Typography>
            <Grid container spacing={2}>
              {Object.entries(paymentMethodTotals).map(([method, total]) => (
                <Grid item xs={6} md={2} key={method}>
                  <Card
                    sx={{
                      border: "1px solid",
                      borderColor: "grey.200",
                      borderRadius: 2,
                      boxShadow: "none",
                      "&:hover": { boxShadow: "0 2px 8px rgba(0,0,0,0.1)" },
                    }}
                  >
                    <CardContent>
                      <Typography variant="body2" color="text.secondary">
                        Total {method.charAt(0).toUpperCase() + method.slice(1)}
                      </Typography>
                      <Typography variant="h6" sx={{ fontWeight: "bold", color: "primary.dark" }}>
                        {formatCurrency(total)}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Paper>
        </Box>

        {/* Transaction Detail Modal */}
        <Dialog open={showTransactionDetail} onClose={() => setShowTransactionDetail(false)} maxWidth="md" fullWidth>
          <DialogTitle>
            Order Details - {selectedTransaction?.order_code}
            <IconButton sx={{ position: "absolute", right: 8, top: 8 }} onClick={() => setShowTransactionDetail(false)}>
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            {selectedTransaction && (
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>
                    Order Information
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order Code
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {selectedTransaction.order_code}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order ID
                    </Typography>
                    <Typography variant="body1">{selectedTransaction.order_id}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Date & Time
                    </Typography>
                    <Typography variant="body1">{formatDate(selectedTransaction.order_date)}</Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Order Status
                    </Typography>
                    <Chip
                      label={selectedTransaction.order_status}
                      color={getOrderStatusColor(selectedTransaction.order_status) as any}
                      sx={{ mt: 0.5 }}
                    />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Staff
                    </Typography>
                    <Typography variant="body1">{selectedTransaction.order_by}</Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>
                    Payment Information
                  </Typography>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Payment Method
                    </Typography>
                    <Chip label={selectedTransaction.mode_of_payment} color="secondary" sx={{ mt: 0.5 }} />
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Amount Paid
                    </Typography>
                    <Typography variant="h5" sx={{ fontWeight: "bold", color: "primary.main" }}>
                      {formatCurrency(selectedTransaction.amount_paid)}
                    </Typography>
                  </Box>
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Balance Due
                    </Typography>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        color: Number.parseFloat(selectedTransaction.balance_due || "0") > 0 ? "error.main" : "success.main",
                      }}
                    >
                      {formatCurrency(selectedTransaction.balance_due)}
                    </Typography>
                  </Box>
                  
                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Tab Balance
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {formatCurrency(selectedTransaction.tabBalance)}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Debt Balance
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontWeight: "bold",
                        color: (selectedTransaction.debtBalance || 0) > 0 ? "error.main" : "success.main",
                      }}
                    >
                      {formatCurrency(selectedTransaction.debtBalance)}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Wallet Details
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {formatCurrency(selectedTransaction.walletDetails)}
                    </Typography>
                  </Box>

                  <Box sx={{ mb: 2 }}>
                    <Typography variant="body2" color="text.secondary">
                      Wallet Details (L)
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
                      {formatCurrency(selectedTransaction?.walletDetails_l)}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ my: 2 }} />
                  <Typography variant="h6" gutterBottom>
                    Order Items ({selectedTransaction?.items?.length || 0})
                  </Typography>
                  <List>
                    {selectedTransaction?.items?.map((item, index) => (
                      <ListItem key={index} divider>
                        <ListItemText
                          primary={
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <Typography variant="subtitle1">{item.product_name}</Typography>
                              <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                {formatCurrency(item?.total_amount)}
                              </Typography>
                            </Box>
                          }
                          secondary={
                            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
                              <Typography variant="body2">
                                Qty: {item.quantity} × {formatCurrency(item.price)}
                              </Typography>
                              <Chip
                                label={item.item_status}
                                size="small"
                                color={getOrderStatusColor(item?.item_status) as any}
                              />
                            </Box>
                          }
                        />
                      </ListItem>
                    )) || (
                      <ListItem>
                        <ListItemText primary="No items found" />
                      </ListItem>
                    )}
                  </List>
                </Grid>
              </Grid>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setShowTransactionDetail(false)}>Close</Button>
            <Button variant="contained" startIcon={<Download />}>
              Download Receipt
            </Button>
          </DialogActions>
        </Dialog>

        {/* Enhanced Verification Dialog with Images */}
        <Dialog open={verifyDialogOpen} onClose={() => setVerifyDialogOpen(false)} maxWidth="lg" fullWidth>
          <DialogTitle sx={{ 
            bgcolor: 'primary.main', 
            color: 'white',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 2
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <CheckCircle sx={{ mr: 1 }} />
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                Verify Transaction 
              </Typography>
            </Box>
            <IconButton 
              onClick={() => setVerifyDialogOpen(false)} 
              sx={{ color: 'white' }}
            >
              <Close />
            </IconButton>
          </DialogTitle>
          
          <DialogContent dividers sx={{ p: 0 }}>
            {verifyDialogLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 300 }}>
                <CircularProgress size={60} />
              </Box>
            ) : transactionToVerify ? (
              <Box sx={{ p: 3 }}>
                {/* Header Summary */}
                <Card sx={{ mb: 3, bgcolor: 'success.light', color: 'white' }}>
                  <CardContent>
                    <Grid container spacing={2} alignItems="center">
                      <Grid item xs={12} md={6}>
                     <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
  {transactionToVerify.product_id_type} - {
    transactionToVerify.product_id_type === "GiftCard"
      ? transactionToVerify.giftcardType
      : transactionToVerify.cryptoType
  } Transaction
</Typography>
                        <Typography variant="body2">
                          {formatDate(transactionToVerify.order_date)}
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }}>
                          Customer: {transactionToVerify.customer_name || "N/A"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6} sx={{ textAlign: { md: 'right' } }}>
                        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
                          {formatCurrency(transactionToVerify.amount_paid)}
                        </Typography>
                        <Box sx={{ display: 'flex', justifyContent: { md: 'flex-end' }, gap: 1, mt: 1, flexWrap: 'wrap' }}>
                          <Chip 
                            label={transactionToVerify.active_status} 
                            color={transactionToVerify.active_status === "COMPLETED" ? "success" : "warning"}
                            sx={{ fontWeight: 'bold' }}
                          />
                          <Chip 
                            label={transactionToVerify.is_verified === 1 ? "VERIFIED" : "PENDING VERIFICATION"} 
                            color={transactionToVerify.is_verified === 1 ? "success" : "warning"}
                            sx={{ fontWeight: 'bold' }}
                          />
                          <Chip 
                            label={transactionToVerify.is_audited === 1 ? "AUDITED" : "PENDING AUDIT"} 
                            color={transactionToVerify.is_audited === 1 ? "success" : "primary"}
                            sx={{ fontWeight: 'bold' }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>

                <Grid container spacing={3}>
                  {/* Order Information */}
                  <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <Receipt sx={{ mr: 1, color: 'primary.main' }} />
                          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Order Information
                          </Typography>
                        </Box>
                        
                        <Box sx={{ mb: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Order Code</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.order_code}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Order ID</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.order_id}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Date & Time</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{formatDate(transactionToVerify.order_date)}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Active Status</Typography>
                            <Box sx={{ textAlign: 'right', flex: 1 }}>
                              <Chip label={transactionToVerify.active_status} color={transactionToVerify.active_status === "COMPLETED" ? "success" : "warning"} size="small" />
                            </Box>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Staff Name</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.staff_name}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Staff ID</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.order_by}</Typography>
                          </Box>
<Box 
  sx={{ 
    display: 'flex', 
    justifyContent: 'space-between', 
    alignItems: 'flex-start',   // important so wrapped text aligns properly
    py: 1.5 
  }}
>
  <Typography 
    variant="body2" 
    color="text.secondary" 
    sx={{ 
      minWidth: 140, 
      fontWeight: 'medium' 
    }}
  >
    Gift Card Code
  </Typography>

  <Typography 
    variant="body2" 
    sx={{ 
      fontWeight: 'medium', 
      textAlign: 'right',
      flex: 1,
      whiteSpace: 'pre-wrap',
      wordBreak: 'break-word',
      overflowWrap: 'break-word',
      maxWidth: 200 
    }}
  >
    {transactionToVerify.product_face_code 
      ? transactionToVerify.product_face_code.split(',').join('\n') 
      : "N/A"}
  </Typography>
</Box>



                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Payment Information */}
                  <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <AttachMoney sx={{ mr: 1, color: 'primary.main' }} />
                          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Payment Information
                          </Typography>
                        </Box>
                        
                        <Box sx={{ mb: 2 }}>
                          {/* Payment Method */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Payment Method</Typography>
                            <Box sx={{ textAlign: 'right', flex: 1 }}>
                              <Chip label={transactionToVerify.mode_of_payment_real} color="secondary" size="small" />
                            </Box>
                          </Box>

                          {/* Conditional Amount Fields */}
                          {transactionToVerify?.product_id_type === "GiftCard" && (
                            <> 
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Card Amount</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main', textAlign: 'right', flex: 1 }}>
                                  {Number(transactionToVerify.card_amount).toLocaleString()}
                                </Typography>
                              </Box>


                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Card Unit</Typography>
                                                              <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main', textAlign: 'right', flex: 1 }}>
                                                                {Number(transactionToVerify.cardUnit).toLocaleString()}
                                                              </Typography>
                                                            </Box>
                              
                              
                                   
                              
                              
                                                                   <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Total Card Value</Typography>
                                                              <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main', textAlign: 'right', flex: 1 }}>
                                                                {Number(transactionToVerify.cardValue).toLocaleString()}
                                                              </Typography>
                                                            </Box>
                              
                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}> Unit Price</Typography>
                                                              <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main', textAlign: 'right', flex: 1 }}>
                                                                {formatCurrency(Number(transactionToVerify.unitPrice))}
                              
                                                                                             
                              
                                                              </Typography>
                                                            </Box>
                              

                              {/* RMB Value */}
                              {transactionToVerify.processor_category === "CHINESE" && (
                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                  <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>RMB Value</Typography>
                             <Typography
  variant="body2"
  sx={{
    fontWeight: 'bold',
    color:
      Number.parseFloat(transactionToVerify.rmbValue || "0") > 0
        ? 'success.main'
        : 'error.main',
    textAlign: 'right',
    flex: 1
  }}
>
  {
    Number(transactionToVerify.rmbValue || 0) *
    Number(transactionToVerify.cardUnit || 0)
  }
</Typography>

                                </Box>
                              )}
                            </>
                          )}

                          {transactionToVerify?.product_id_type === "Crypto" && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Crypto Amount</Typography>
                              <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main', textAlign: 'right', flex: 1 }}>
                                {transactionToVerify.cryptoType} {Number(transactionToVerify.cryptoAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                              </Typography>
                            </Box>
                          )}

                          {transactionToVerify?.crypto_value && (
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Crypto Value</Typography>
                              <Typography variant="body2" sx={{ fontWeight: 'bold', color: 'success.main', textAlign: 'right', flex: 1 }}>
                                {(transactionToVerify.crypto_value)}
                              </Typography>
                            </Box>
                          )}

                          {/* Cost Price */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Cost Price</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: Number.parseFloat(transactionToVerify.balance_due || "0") > 0 ? 'error.main' : 'success.main', textAlign: 'right', flex: 1 }}>
                              {formatCurrency(transactionToVerify.costPrice)}
                            </Typography>
                          </Box>

                          {/* Selling Price */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Selling Price</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: Number.parseFloat(transactionToVerify.balance_due || "0") > 0 ? 'error.main' : 'success.main', textAlign: 'right', flex: 1 }}>
                              {formatCurrency(transactionToVerify.sellingPrice)}
                            </Typography>
                          </Box>

                          {/* Commission */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Commission</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'bold', color: Number.parseFloat(transactionToVerify.commission || "0") > 0 ? 'success.main' : 'error.main', textAlign: 'right', flex: 1 }}>
                              {formatCurrency(transactionToVerify.commission)}
                            </Typography>
                          </Box>

                          {/* Payment Status */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Payment Status</Typography>
                            <Box sx={{ textAlign: 'right', flex: 1 }}>
                              <Chip label={transactionToVerify.payment_status === 1 ? "PAID" : "PENDING"} color={transactionToVerify.payment_status === 1 ? "success" : "warning"} size="small" />
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Customer Information */}
                  <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <Person sx={{ mr: 1, color: 'primary.main' }} />
                          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Customer Information
                          </Typography>
                        </Box>
                        
                        <Box sx={{ mb: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Customer Name</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.customer_name || "N/A"}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Customer Phone</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.customer_phone || "N/A"}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Customer Email</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.customer_email || "N/A"}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Account Name</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.customer_account_name || "N/A"}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Account Number</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.customer_account_number || "N/A"}</Typography>
                          </Box>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Bank Name</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.bank_name || "N/A"}</Typography>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                  {/* Transaction Details */}
                  <Grid item xs={12} md={6}>
                    <Card sx={{ height: '100%' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <Receipt sx={{ mr: 1, color: 'primary.main' }} />
                          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                            Transaction Details
                          </Typography>
                        </Box>
                        
                        <Box sx={{ mb: 2 }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Created At</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{formatDate(transactionToVerify.created_at)}</Typography>
                          </Box>

                          {/* Conditional: GiftCard vs Crypto */}
                          {transactionToVerify.product_id_type === "GiftCard" && (
                            <> 
                              {transactionToVerify.processor_category === "CHINESE" && (
                                <>
                                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>RMB Value</Typography>
                                  <Typography
  variant="body2"
  sx={{
    fontWeight: 'bold',
    color:
      Number.parseFloat(transactionToVerify.rmbValue || "0") > 0
        ? 'success.main'
        : 'error.main',
    textAlign: 'right',
    flex: 1
  }}
>
  {Number(transactionToVerify.rmbValue || 0) *
    Number(transactionToVerify.cardUnit || 0)}
</Typography>

                                  </Box>

                                  {/* Naira Rate */}
                                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Naira Rate</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{formatCurrency(transactionToVerify.naira_rate)}</Typography>
                                  </Box>
                                </>
                              )}
                              
                              {/* Processor / Type */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Processor / Type / Category</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>
                                  {transactionToVerify.external_processor} / {transactionToVerify.processor_type} / {transactionToVerify.processor_category}
                                </Typography>
                              </Box>

                              {/* Load Type */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Load Type</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.load_type || "N/A"}</Typography>
                              </Box>

                              {/* Card Rate */}
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Card Rate</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.card_rate}</Typography>
                              </Box>
                            </>
                          )}

                          {transactionToVerify.product_id_type === "Crypto" && (
                            <>
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Crypto Type</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{transactionToVerify.cryptoType}</Typography>
                              </Box>
                              
                              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Crypto Amount</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{Number(transactionToVerify.cryptoAmount).toFixed(2)}</Typography>
                              </Box>

                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Cost Rate </Typography>
                                                              <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{Number(transactionToVerify.costRate).toFixed(2)}</Typography>
                                                            </Box>
                              
                              
                                                               
                                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                                                              <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Selling Rate </Typography>
                                                              <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{Number(transactionToVerify.sellingRate).toFixed(2)}</Typography>
                                                            </Box>
                            </>
                          )}

                          {/* Last Updated */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Last Updated</Typography>
                            <Typography variant="body2" sx={{ fontWeight: 'medium', textAlign: 'right', flex: 1 }}>{formatDate(transactionToVerify.last_updated)}</Typography>
                          </Box>

                          {/* Audit Status */}
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 1.5 }}>
                            <Typography variant="body2" color="text.secondary" sx={{ minWidth: 140, fontWeight: 'medium' }}>Audit Status</Typography>
                            <Box sx={{ textAlign: 'right', flex: 1 }}>
                              <Chip label={transactionToVerify.is_audited === 1 ? "AUDITED" : "PENDING AUDIT"} color={transactionToVerify.is_audited === 1 ? "success" : "warning"} size="small" />
                            </Box>
                          </Box>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>

                    {/* Proof of Payment Section */}
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 3, display: 'flex', alignItems: 'center' }}>
                  <Receipt sx={{ mr: 1, color: 'primary.main' }} />
                  Document Proofs
                </Typography>
                
                <Grid container spacing={3}>
                  {/* Proof of Payment */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
                        Proof of Payment
                      </Typography>
                      <Box sx={{ border: '2px solid', borderColor: 'divider', borderRadius: 2, p: 2, display: 'inline-block' }}>
                        <img
                          height="200"
                          width="200"
                          alt="Proof of Payment"
                          src={`${baseUrl()}assets/img/gift_card/${transactionToVerify.proof_of_payment || "zillyuser.jpg"}`}
                          style={{ 
                            objectFit: 'cover', 
                            borderRadius: 8,
                            border: '1px solid #e0e0e0'
                          }}
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Payment confirmation document
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Proof of Job Start */}
                  <Grid item xs={12} md={6}>
                    <Box sx={{ textAlign: 'center' }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2, color: 'primary.main' }}>
                        Proof of Job Start
                      </Typography>
                      <Box sx={{ border: '2px solid', borderColor: 'divider', borderRadius: 2, p: 2, display: 'inline-block' }}>
                        <img
                          height="200"
                          width="200"
                          alt="Proof of Job Start"
                          src={`${baseUrl()}assets/img/gift_card_crypto_start/${transactionToVerify.proof_of_jobstart || "zillyuser.jpg"}`}
                          style={{ 
                            objectFit: 'cover', 
                            borderRadius: 8,
                            border: '1px solid #e0e0e0'
                          }}
                        />
                      </Box>
                      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                        Transaction initiation proof
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>

                  {/* Financial Summary */}
                  <Grid item xs={12}>
                    <Card sx={{ bgcolor: 'grey.50' }}>
                      <CardContent>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, display: 'flex', alignItems: 'center' }}>
                          <AttachMoney sx={{ mr: 1 }} />
                          Financial Summary
                        </Typography>
                        <Grid container spacing={2}>
                          <Grid item xs={6} md={3}>
                            <Card sx={{ textAlign: 'center', p: 2, bgcolor: 'white', boxShadow: 2 }}>
                              <CardContent sx={{ p: '0 !important' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: 'info.main' }}><AttachMoney /></Box>
                                {transactionToVerify?.product_id_type === "GiftCard" ? (
                                  <>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: "medium" }}>Total Card Amount</Typography>
                                  <Typography
  variant="h6"
  sx={{ fontWeight: "bold", color: "info.main" }}
>
  {Number(transactionToVerify.card_amount * transactionToVerify.cardUnit).toLocaleString()}
</Typography>

                                  </>
                                ) : transactionToVerify?.product_id_type === "Crypto" ? (
                                  <>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: "medium" }}>Crypto Amount</Typography>
                                    <Typography variant="h6" sx={{ fontWeight: "bold", color: "info.main" }}>
                                      {transactionToVerify.cryptoType} {Number(transactionToVerify.cryptoAmount).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </Typography>
                                  </>
                                ) : null}
                              </CardContent>
                            </Card>
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <Card sx={{ textAlign: 'center', p: 2, bgcolor: 'white', boxShadow: 2 }}>
                              <CardContent sx={{ p: '0 !important' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: 'primary.main' }}><Receipt /></Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 'medium' }}>Cost Price</Typography>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'primary.main' }}>{formatCurrency(transactionToVerify.costPrice)}</Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <Card sx={{ textAlign: 'center', p: 2, bgcolor: 'white', boxShadow: 2 }}>
                              <CardContent sx={{ p: '0 !important' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: 'success.main' }}><CheckCircle /></Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 'medium' }}>Selling Price</Typography>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: 'success.main' }}>{formatCurrency(transactionToVerify.sellingPrice)}</Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                          <Grid item xs={6} md={3}>
                            <Card sx={{ textAlign: 'center', p: 2, bgcolor: 'white', boxShadow: 2 }}>
                              <CardContent sx={{ p: '0 !important' }}>
                                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 1, color: Number.parseFloat(transactionToVerify.commission || "0") > 0 ? 'success.main' : 'success.main' }}><Warning /></Box>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1, fontWeight: 'medium' }}>Commission</Typography>
                                <Typography variant="h6" sx={{ fontWeight: 'bold', color: Number.parseFloat(transactionToVerify.commission || "0") > 0 ? 'success.main' : 'success.main' }}>{formatCurrency(transactionToVerify.commission)}</Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        </Grid>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
            ) : null}
          </DialogContent>
          
          <DialogActions sx={{ p: 3, bgcolor: 'grey.50' }}>
            <Button 
              onClick={() => setVerifyDialogOpen(false)} 
              variant="outlined"
              startIcon={<Close />}
              sx={{ minWidth: 100 }}
            >
              Cancel
            </Button>
            <Button
              onClick={handleVerifyTransaction}
              variant="contained"
              color="primary"
              disabled={isVerifying || verifyDialogLoading || transactionToVerify?.is_verified === 1}
              startIcon={isVerifying ? <CircularProgress size={16} /> : <CheckCircle />}
              sx={{ minWidth: 140 }}
            >
              {isVerifying ? "Verifying..." : transactionToVerify?.is_verified === 1 ? "Already Verified" : "Verify Transaction"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Image Preview Dialog */}
        <Dialog open={imageDialogOpen} onClose={() => setImageDialogOpen(false)} maxWidth="lg" fullWidth>
          <DialogTitle>
            Image Preview
            <IconButton sx={{ position: "absolute", right: 8, top: 8 }} onClick={() => setImageDialogOpen(false)}>
              <Close />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
              <img
                src={`${baseUrl}${selectedImage}`}
                alt="Transaction proof"
                style={{ 
                  maxWidth: '100%', 
                  maxHeight: '70vh', 
                  objectFit: 'contain',
                  borderRadius: 8
                }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setImageDialogOpen(false)}>Close</Button>
          </DialogActions>
        </Dialog>
      </IonContent>
    </IonPage>
  )
}

export default ManagerSalesReportPage_R_Giftcard